import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const Addon = Loadable(
  lazy(() =>
    import("./Addon").then(({ Addon }) => ({
      default: Addon,
    })),
  ),
);

export const addonRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.addons,
    exact: true,
    element: (
      <AuthorizedRoute>
        <Addon />
      </AuthorizedRoute>
    ),
  },
];

